/**
 * Saldo de créditos de IA, numa conta só para o menu e para o Painel.
 *
 * O backend já mandava os números certos — `/ai/credits` e `/user/usage`
 * devolvem o mesmo saldo. A divergência estava nas telas antigas: o topo
 * mostrava restantes sobre o total do mês ("1001 /1000", porque o comprado
 * entra nos restantes e não no total) e o Painel mostrava usados sobre o total
 * ("0 / 1000"). Aqui a régua é uma só: restantes de (mês + comprados).
 *
 * Recebe os campos já sem o prefixo de cada rota, porque as duas nomeiam
 * diferente (`total_credits` lá, `total` aqui).
 */
export const saldoDeCreditos = ({ total = 0, usados = 0, extra = 0, restantes }) => {
  const doMes = Math.max(0, total - usados);
  const saldo = restantes ?? doMes + extra;
  const capacidade = total + extra;

  return {
    restantes: saldo,
    capacidade,
    doMes,
    extra,
    pct: capacidade > 0 ? Math.min(100, Math.round((saldo / capacidade) * 100)) : 0
  };
};
